import React from 'react';
import { HtmlTable } from '../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { TableHead } from './components/TableHead';
import { TableBody } from './components/TableBody';
import { TableRow } from './components/TableRow';
import { PDFTitle } from '../PDFRenderer/components/PDFTitle/PDFTitle';
import { PdfPageWrapper } from '../PDFRenderer/PDFRenderer.styles';
import { InflowOutflowDTO, PeopleDTO, PeriodDTO } from './ProjectedCashFlowReport.meta';

interface Props {
  title: string;
  people: PeopleDTO[];
  periods: PeriodDTO[];
  principalAges: string[];
  spouseAges: string[];
  inflows: InflowOutflowDTO[];
  outflows: InflowOutflowDTO[];
  inflowsTotals: number[];
  outflowsTotals: number[];
  netCashflow: number[];
}

export const ProjectedCashFlowReportPrint = ({
  title,
  people,
  periods,
  principalAges,
  spouseAges,
  inflows,
  outflows,
  inflowsTotals,
  outflowsTotals,
  netCashflow,
}: Props) => {
  return (
    <PdfPageWrapper>
      <PDFTitle title={title} />
      <HtmlTable variant="basic">
        <table>
          <thead>
            <TableHead columns={periods} title="Period" />
            <TableHead columns={principalAges} title={people[0].Name} />
            {people.length > 1 && <TableHead columns={spouseAges} title={people[1]?.Name} />}
          </thead>
          <tbody>
            <tr>
              <td colSpan={6}>
                <Text fontSize="h6" fontWeight={600}>
                  Inflow
                </Text>
              </td>
            </tr>
            <TableBody rows={inflows} />
            <TableRow
              title={'Total Inflow'}
              cells={inflowsTotals}
              forceOdd={true}
              color="success.500"
              fontWeight={600}
            />
            <tr>
              <td colSpan={6}>
                <Text fontSize="h6" fontWeight={600}>
                  Outflow
                </Text>
              </td>
            </tr>
            <TableBody rows={outflows} />
            <TableRow
              title={'Total Outflow'}
              cells={outflowsTotals}
              forceOdd={true}
              color="error.500"
              fontWeight={600}
            />
            <TableRow
              title={'Net Cash Flow'}
              cells={netCashflow}
              forceOdd={true}
              color="black"
              fontWeight={600}
              fontSize="h6"
            />
          </tbody>
        </table>
      </HtmlTable>
    </PdfPageWrapper>
  );
};
